// COMPONENT IMPORTS
import { apiInstance } from "store/api/axiosApi";
import {
  GET_CUSTOM_PLANS,
  GET_DASHBOARD_DATA,
  GET_PLANS,
  GET_SCHEDULE_DATA,
  LEAD_DATA,
  GET_HOLIDAY_LIST,
  GET_PORTAL_SETTINGS,
  GET_MAINTENANCE_SETTINGS,
  GET_STATE_DISCLAIMER,
  GET_SCHEDULE_INTERVAL,
  GET_UPDATE_SUBSCRIPTION_DATA,
  GET_UPDATE_SCHEDULE_DATA,
  GET_SCHEDULE_PAYMENT,
} from "store/api/constApi";
import { withSlug } from "utils/currentSlug";

/* ------------------------------------- DASHBOARD SERVICES ------------------------------------- */
  
export const getDashboardData = (params: any) => {
  return apiInstance.get(GET_DASHBOARD_DATA, { params });
};

export const getPaymentScheduleData = (params: any) => {
  return apiInstance.get(GET_SCHEDULE_DATA, { params });
};

export const getUpdateSubscriptionData = (params: any) => {};

export const getUpdateScheduleData = (params: any) => {
  return apiInstance.get(GET_UPDATE_SCHEDULE_DATA, { params });
};

export const getLeadData = (params: any) => {
  return apiInstance.get(LEAD_DATA, { params });
};

export const getPaymentDates = (payload: any) => {
  return apiInstance.post(GET_SCHEDULE_PAYMENT, payload);
};

export const getNewPlan = (payload: any) => {
  return apiInstance.post(GET_PLANS, payload);
};

export const getCustomPlan = (payload: any) => {
  return apiInstance.post(GET_CUSTOM_PLANS, withSlug(payload));
};

export const getHolidays = (params: any) => {
  return apiInstance.get(GET_HOLIDAY_LIST, { params });
};

export const getPortalSettings = (params: any) => {
  return apiInstance.get(GET_PORTAL_SETTINGS, { params });
};

// The portal waits on this before its first render, so it is capped: a slow
// or unreachable API must not leave the customer on a blank screen.
const MAINTENANCE_SETTINGS_TIMEOUT = 5000;

export const getMaintenanceSettings = () => {
  return apiInstance.get(GET_MAINTENANCE_SETTINGS, {
    timeout: MAINTENANCE_SETTINGS_TIMEOUT,
  });
};

export const fetchScheduleInterval =(payload: any) => {
  return apiInstance.post(GET_SCHEDULE_INTERVAL, payload);
};

export const getStateDisclaimer = (params: any) => {
  return apiInstance.get(GET_STATE_DISCLAIMER, { params });
};
